import isBot from 'isbot';

const speedCurveTesterUserAgentRegex = '^Mozilla/5.0.*PTST\\/.*$';
isBot.extend(['kube-probe', 'NodePing', speedCurveTesterUserAgentRegex]);

const isBotFromUserAgent = userAgent => isBot(userAgent);

export default isBotFromUserAgent;
